module.exports = __webpack_public_path__ + "img/study_content_smallbg.484d0081.png";